// extracted by mini-css-extract-plugin
module.exports = {"Experience":"Experience_Experience__28Re0","box":"Experience_box___UrES"};